import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const viewPageEnterNewCarDetails = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_enter_new_car_details",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPageEnterNewCarDetailsMounted = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_enter_new_car_details_mounted",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnEnterNewCarDetailsCta = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_enter_new_car_details_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const newCarDeliveryDateEntered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "new_car_delivery_date_entered",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPageNewCarFewMoreDetails = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_new_car_few_more_details",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnNewCarFewMoreDetailsCta = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_new_car_few_more_details_cta",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const engineNumberUpdated = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_engine_number_update_new_car",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const chassisNumberUpdated = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_chassis_number_update_new_car",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });
